import { apiRoutes } from "@constants/api-routes";
import { handleRequestWithBody } from "@utils/http-util";
import { RequestTypes } from "@enums/request-types";
import { AdvancedWorkflowDetailsConfiguration } from "@idw-types/data/workflow-details-configuration";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { injectCustomIdParameter } from "@utils/parameter-injector";
import { WORKFLOW_ID_PATTERN } from "@constants/url-parameter-patterns";

type UpdateWorkflowDetailsRequestResponse = {
    transferObject: AdvancedWorkflowDetailsConfiguration;
};

export const updateWorkflowDetailsRequest = async (
    workflowId: string,
    body: AdvancedWorkflowDetailsConfiguration
): Promise<GenericNetworkResponse<UpdateWorkflowDetailsRequestResponse>> => {
    const route = injectCustomIdParameter(
        apiRoutes.serviceConfiguration.workflowConfig.axnAdmin.workflow,
        workflowId,
        WORKFLOW_ID_PATTERN
    );

    const finalBody = {
        ...body,
        appliedProfiles: body.workflow.appliedProfiles,
        workflowVariants: body.workflow.workflowVariants
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.PUT, route, finalBody);
    return { data, error, body };
};